export const validateField = (values) => {
  let errors = {}
  if (!values.title) {
    errors.title = 'Required!'
  }
  if (!values.requesterUser) {
    errors.requesterUser = 'Required!'
  }
  if (!values.requestForCode) {
    errors.requestForCode = 'Required!'
  }
  if (!values.companyCode) {
    errors.companyCode = 'Required!'
  }
  if (!values.typeOfBond) {
    errors.typeOfBond = 'Required!'
  }else{
    if (values.typeOfBond=='other') {
      if (!values.typeOfBondOther) {
        errors.typeOfBondOther = 'Required!'
      }
    }
  }
  if (!values.amount) {
    errors.amount = 'Required!'
  }
  if (!values.startDate) {
    errors.startDate = 'Required!'
  }
  if (!values.isNoExpireDate) {
    if (!values.dueDate) {
      errors.dueDate = 'Required!'
    }
  }
  if (!values.bankGuaranteeNumber) {
    errors.bankGuaranteeNumber = 'Required!'
  }
  if (!values.bankOwner) {
    errors.bankOwner = 'Required!'
  }
  if(values.contacts){
    if(values.contacts.length>0){
      let filterContact = values.contacts.filter(x=>!x.firstName||!x.lastName||!x.email)
      if(filterContact.length>0){
        errors.contactsAlert = 'Required!'
      }
    }else{
      errors.contactsAlert = 'Required!'
    }
  }else{
    errors.contactsAlert = 'Required!'
  }
  if(!values.isContactValid){
    errors.contactsAlert = 'Contact email is not available!'
  }
  if (!values.bgc03||values.bgc03.length==0) {
    if(!values.attachments||!values.attachments.find(x=>x.documentCode=='BGC03'&&!x.deleted)){
      errors.bgc03 = 'Required!'
    }
  }
  
  return errors
}

export const validateApproveField = (values) => {
  let errors = {}
  if(values.isActionReturn){
    if(!values.returnDate) {
      errors.returnDate = 'Required!'
    }
  }else{
    if(!values.comment) {
      errors.comment = 'Required!'
    }
    if (!values.bgc03||values.bgc03.length==0) {
      if(!values.attachments||!values.attachments.find(x=>x.documentCode=='BGC03'&&!x.deleted)){
        errors.bgc03 = 'Required!'
      }
    }
  }
  
  return errors
}